import React from 'react';
import { Phone, Mail, Instagram, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import LogoMark from './LogoMark';
import { agencyInfo } from '../data/mock';

const StudioFooter = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="contato" data-testid="studio-footer" className="bg-[#050508] border-t border-white/10">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="space-y-6">
            <LogoMark className="text-3xl md:text-4xl" showTagline={true} />
            <p className="text-[#A1A1AA] leading-relaxed font-light italic text-sm">
              Ideias ganham vida.
            </p>
            <div className="flex items-center space-x-3">
              <a href={`https://instagram.com/${agencyInfo.instagram.replace('@', '')}`} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 hover:bg-[#2540A3] border border-white/10 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110">
                <Instagram className="w-4 h-4" />
              </a>
              <a href={`https://wa.me/${agencyInfo.whatsapp}`} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 hover:bg-[#F59E0B] border border-white/10 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110">
                <Phone className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">Navegar</h4>
            <ul className="space-y-3 text-sm">
              <li><button onClick={() => scrollToSection('home')} className="text-[#A1A1AA] hover:text-[#2540A3] transition-colors">Início</button></li>
              <li><button onClick={() => scrollToSection('possibilidades')} className="text-[#A1A1AA] hover:text-[#2540A3] transition-colors">O Espaço</button></li>
              <li><button onClick={() => scrollToSection('cenarios')} className="text-[#A1A1AA] hover:text-[#2540A3] transition-colors">Cenários</button></li>
              <li><button onClick={() => scrollToSection('experiencia')} className="text-[#A1A1AA] hover:text-[#2540A3] transition-colors">Experiência</button></li>
              <li><button onClick={() => scrollToSection('waitlist')} className="text-[#F59E0B] hover:text-white transition-colors font-medium">Lançamento 2027</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">Serviços</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/filmagem-foz-do-iguacu" className="text-[#A1A1AA] hover:text-[#2540A3] transition-colors">Filmagem em Foz do Iguaçu</Link></li>
              <li><Link to="/gestao-presencial" className="text-[#A1A1AA] hover:text-[#2540A3] transition-colors">Marketing Terceirizado</Link></li>
              <li><Link to="/criacao-de-sites" className="text-[#A1A1AA] hover:text-[#2540A3] transition-colors">Criação de Sites</Link></li>
              <li><Link to="/landing-pages" className="text-[#A1A1AA] hover:text-[#2540A3] transition-colors">Landing Pages</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">Contato</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={`tel:${agencyInfo.phone}`} className="flex items-start gap-3 text-[#A1A1AA] hover:text-[#2540A3] transition-colors">
                  <Phone className="w-4 h-4 flex-shrink-0 mt-0.5" />
                  <span>{agencyInfo.phone}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${agencyInfo.email}`} className="flex items-start gap-3 text-[#A1A1AA] hover:text-[#2540A3] transition-colors">
                  <Mail className="w-4 h-4 flex-shrink-0 mt-0.5" />
                  <span className="break-all">{agencyInfo.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#A1A1AA]">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span>Foz do Iguaçu — Paraná</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10">
          <div className="rounded-xl border border-[#2540A3]/25 bg-[#2540A3]/5 backdrop-blur-sm px-6 py-5 text-center">
            <p className="text-sm md:text-base text-[#D4D4D8] font-light">
              <span className="text-[#F59E0B] uppercase tracking-[0.3em] text-xs font-bold">Preview</span>
              <span className="mx-3 text-white/20">|</span>
              Projeto em desenvolvimento. Chegada prevista para 2027.
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-6">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#5A5A5A]">
            <p>© {currentYear} Coutin Studio (preview). Todos os direitos reservados.</p>
            <p className="text-center md:text-right">CNPJ operacional: Coutin Agência · Foz do Iguaçu — PR</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default StudioFooter;
